export const getWindowHeight = (customHeight?: number) => {
  const indexHeight = 150;
  return `h-${
    window.innerHeight - indexHeight - (customHeight ? customHeight : 0)
  }`;
};
